import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AuthService } from '@labqc-core/auth.service';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-user-button-dialog',
  templateUrl: './user-button-dialog.component.html',
  styleUrls: ['./user-button-dialog.component.scss']
})
export class UserButtonDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<UserButtonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public afAuth: AngularFireAuth,
    public auth: AuthService,
    public router: Router,
    private messageService: MessageService,

  ) { }

  ngOnInit() {
  }

  fireLogout() {
    this.afAuth.signOut();
    this.router.navigate(['/']);
    this.messageService.add({ severity: 'warn', summary: 'Cierre de Sesión', detail: 'Su sesión se ha cerrado' });
    this.dialogRef.close();
  }

}
